import { QueryEntity } from "@datorama/akita";
import { singleton } from "tsyringe";

import ShareWishlistsStore, {
    ShareWishlistsState,
} from "../stores/ShareWishlistsStore";

@singleton()
export class ShareWishlistsQuery extends QueryEntity<ShareWishlistsState> {
    constructor(shareWishlistsStore: ShareWishlistsStore) {
        super(shareWishlistsStore);
    }

    status$ = this.select((s) => s.status);
    loadMoreStatus$ = this.select((s) => s.loadMoreStatus);
}
